import apiCall from '../../../utils/api';

export const fetchAttentamenteDashboard = async <T>(
    container: string,
    uoaId: string,
    dashboard: 'activities' | 'beneficiaries',
    params: Record<string, unknown>,
): Promise<T> => {
    const res = await apiCall({
        url: `containers/${container}/uoa/${uoaId}/dashboards/attentamente/${dashboard}`,
        params,
    });

    return res.data;
};
